import { useContext } from "react";
import { useLang } from "@/i18n";
import { LenisContext } from "@/lenis-context";
import Logo from "@/components/Logo";
import LegalNotice from "@/components/LegalNotice";
import PrivacyPolicy from "@/components/PrivacyPolicy";

export default function Footer() {
  const { t } = useLang();
  const scrollTo = useContext(LenisContext);

  const links = [
    ["#histoire", t.nav.story, "story"],
    ["#equipe", t.nav.team, "team"],
    ["#etablissements", t.nav.establishments, "establishments"],
    ["#presse", t.nav.press, "press"],
    ["#contact", t.nav.contact, "contact"],
  ];

  return (
    <footer data-testid="site-footer" className="border-t border-paper/10 bg-pine-deep py-14 text-paper">
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <div className="flex flex-col items-start justify-between gap-10 md:flex-row md:items-center">
          <Logo light />
          <nav className="flex flex-wrap gap-x-8 gap-y-3" aria-label="Pied de page">
            {links.map(([href, label, id]) => (
              <a
                key={href}
                href={href}
                data-testid={`footer-nav-${id}`}
                onClick={(e) => {
                  e.preventDefault();
                  scrollTo?.(href);
                }}
                className="text-sm text-paper/70 transition-colors duration-300 hover:text-wood-light"
              >
                {label}
              </a>
            ))}
          </nav>
        </div>
        <div className="mt-12 border-t border-paper/10 pt-8">
          <p className="text-xs uppercase tracking-[0.18em] text-paper/50">{t.footer.tagline}</p>
          <p className="mt-4 text-xs leading-relaxed text-paper/45">{t.footer.legal}</p>
          <div className="mt-3 flex flex-wrap items-center gap-x-5 gap-y-2">
            <LegalNotice />
            <PrivacyPolicy />
            <p className="text-xs text-paper/45">{t.footer.rights}</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
